import React, { useState } from 'react';
import {
  IconButton, Select, MenuItem, Tooltip
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import {
  Edit as EditIcon,
  Circle as CircleIcon,
  Delete as DeleteIcon,
  PlayArrow as PlayArrowIcon,
} from '@mui/icons-material';

import customLocaleText from '../../constants/DataGridLocaleTextConstants.js';

export const customFilterOperators = [
  {
    label: 'Activo/Inactivo',
    value: 'isActiveFilter',
    getApplyFilterFn: (filterItem) => {
      if (!filterItem.value) return null;
      const isActive = filterItem.value === 'Activo';
      return (row) => (row === isActive);
    },
    InputComponent: ({ item, applyValue }) => (
      <Select
        value={item.value || ''}
        onChange={(event) => applyValue({ ...item, value: event.target.value })}
        style={{ width: '100%', marginTop: 'auto' }}
      >
        <MenuItem value="">
          <em>--Seleccione--</em>
        </MenuItem>
        <MenuItem value={"Activo"}>Activo</MenuItem>
        <MenuItem value={"Inactivo"}>Inactivo</MenuItem>
      </Select>
    ),
  },
];

function SpecialRulesDataGrid({ rules, handleOpenDeleteModal, handleOpenModal, handleOpenApplyModal }) {
  const [paginationModel] = useState({ page: 0, pageSize: 10 });

  const columns = [
    {
      display: 'flex',
      field: 'is_active',
      headerName: 'Estado',
      flex: 0.1,
      filterable: true,
      filterOperators: customFilterOperators,
      renderCell: (params) => (
        <CircleIcon
          sx={{
            color: params.row.is_active ? 'green' : 'grey',
          }}
        />
      ),
    },
    { 
      field: 'name', 
      headerName: 'Nombre', 
      flex: 0.3, 
      filterable: true 
    },
    { 
      field: 'priority', 
      headerName: 'Prioridad', 
      flex: 0.1, 
      filterable: true 
    },
    { 
      field: 'description', 
      headerName: 'Descripción', 
      flex: 0.3, 
      filterable: true 
    },
    {
      filterable: false,
      field: 'actions',
      headerName: 'Acciones',
      flex: 0.2,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      renderCell: (params) => {
        return (
          <>
            {handleOpenApplyModal && (
              <Tooltip title="Aplicar regla en línea">
                <IconButton
                  onClick={() => handleOpenApplyModal(params.row)}
                  aria-label="apply"
                  color="primary"
                >
                  <PlayArrowIcon />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Editar">
              <IconButton
                onClick={() => handleOpenModal(params.row)}
                aria-label="edit"
              >
                <EditIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => handleOpenDeleteModal(params.row)}
                aria-label="delete"
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    }
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '600px',
      }}
    >
      <DataGrid
        rows={rules}
        columns={columns}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[5, 10, 15, 20]}
        checkboxSelection={false}
        sx={{ border: 0 }}
        localeText={customLocaleText}
      />
    </div>
  );
}

export default SpecialRulesDataGrid;
